import { render, staticRenderFns } from "./SchedulesAndPlaygrounds.vue?vue&type=template&id=1b808a65&"
import script from "./SchedulesAndPlaygrounds.vue?vue&type=script&lang=js&"
export * from "./SchedulesAndPlaygrounds.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports